import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/_externalProjectionsLayout/reports/runs/$id')({
  beforeLoad: () => getTitleContextSlice('Runs'),
  staticData: {
    owner: CodeOwner.Analytics,
  },
});
